import axios from '../../axios';

export const exportKoreanProductExcel = async (formData) => {
    try {
        const response = await axios.post('/api/uploads-product/export-korean-product-excel',
            formData, { responseType: 'json' });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const exportKoreanCategoryExcel = async (formData) => {
    try {
        const response = await axios.post('/api/uploads-product/export-korean-category-excel',
            formData, { responseType: 'json' });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const exportKoreanDisplayExcel = async (formData) => {
    try {
        const response = await axios.post('/api/uploads-product/export-korean-display-excel',
            formData, { responseType: 'json' });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const exportKrCategoryOrderCsv = async (formData) => {
    try {
        const response = await axios.post('/api/uploads-product/export-korean-category-order-csv',
            formData, { responseType: 'json' });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};


export const importKoreanExcels = async (formData) => {
    try {
        const response = await axios.post('/api/uploads-product/import-korean-all-excels',
            formData, { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'json' });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const importKoreanOrderCsv = async (formData) => {
    try {
        const response = await axios.post('/api/uploads-product/import-korean-order-csv',
            formData, { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'json' });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

// productApi.js의 convertXlsxToKoreanDB 함수 수정
export const convertXlsxToKoreanDB = async () => {
    try {
        const response = await axios.get('/api/convert-product/convert-korean-all-excels');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const LocliazeTextCacheDatabase = async () => {
    try {
        const response = await axios.post('/api/convert-product/localize-text-cache');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const LocliazeImageCacheDatabase = async () => {
    try {
        const response = await axios.post('/api/convert-product/localize-image-url');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const UpdateProductTableByCache = async () => {
    try {
        const response = await axios.post('/api/convert-product/update-product-table-by-cache');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const UpdateImageTableByCache = async () => {
    try {
        const response = await axios.post('/api/convert-product/update-image-table-by-cache');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const ExportJPServerDataCsv = async () => {
    try {
        console.log('Making request to:', axios.defaults.baseURL);
        const response = await axios.post('/api/convert-product/export-jp-server-csv');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        console.error('Request config:', error.config);
        return { success: false, error };
    }
};

export const ImportJPServerDataCsv = async (formData) => {
    try {
        const response = await axios.post('/api/uploads-product/import-jp-server-csv',
            formData, { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'json' });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const LocalizationXlsxExport = async () => {
    try {
        const response = await axios.post('/api/convert-product/translation-xlsx-export');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const LocalizationXlsxUpload = async (formData) => {
    try {
        const response = await axios.post('/api/uploads-product/translation-xlsx-import',
            formData, { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'json' });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const LocalizationXlsxApply = async () => {
    try {
        const response = await axios.get('/api/convert-product/translation-xlsx-apply');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const CheckingLocalizationDataUpdate = async () => {
    try {
        const response = await axios.get('/api/convert-product/check-localization-update');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};

export const CheckingKoreanDataUpdate = async () => {
    try {
        const response = await axios.get('/api/convert-product/check-korean-update');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};
export const ExportJPServerCsvForUpload = async (formData) => {
    try {
        const response = await axios.post('/api/uploads-product/export-jp-server-upload-csv',
            formData, { responseType: 'json' });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};
export const UpdateJPLocalizedCSVTable = async (formData) => {
    try {
        const response = await axios.get('/api/convert-product/update-jp-localized-csv-table');
        return { success: true, data: response.data };
    } catch (error) {
        console.error('API error:', error);
        return { success: false, error };
    }
};